import React from "react";
import { useTranslation } from "react-i18next";
import {
  Stack,
  Typography,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import { DIVISION_COUNT } from "@quest_editor/constants";

function DeliveryDivisionField({
  divisions,
  setDivisions,
}: {
  divisions: number[];
  setDivisions: React.Dispatch<React.SetStateAction<number[]>>;
}) {
  const { t } = useTranslation("questEditor");

  const handleDivisionChange = (division: number) => {
    setDivisions((prev) => {
      if (prev.includes(division)) {
        return prev.filter((d) => d !== division);
      }
      return [...prev, division];
    });
  };

  const handleSelectOdd = () => {
    const oddNumbers = Array.from(
      { length: DIVISION_COUNT },
      (_, i) => i,
    ).filter((i) => i % 2 === 1);
    setDivisions(oddNumbers);
  };

  const handleSelectEven = () => {
    const evenNumbers = Array.from(
      { length: DIVISION_COUNT },
      (_, i) => i,
    ).filter((i) => i % 2 === 0);
    setDivisions(evenNumbers);
  };

  const handleSelectOneThird = () => {
    const oneThird = Array.from({ length: DIVISION_COUNT }, (_, i) => i).filter(
      (i) => i % 3 === 0,
    );
    setDivisions(oneThird);
  };

  const handleSelectOneQuarter = () => {
    const oneQuarter = Array.from(
      { length: DIVISION_COUNT },
      (_, i) => i,
    ).filter((i) => i % 4 === 0);
    setDivisions(oneQuarter);
  };

  return (
    <Stack direction="row" spacing={3}>
      <Grid container spacing={0.5} sx={{ maxWidth: 600 }}>
        {Array.from({ length: DIVISION_COUNT }, (_, i) => (
          <Grid item key={i}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={divisions.includes(i)}
                  onChange={() => handleDivisionChange(i)}
                />
              }
              label={String(i)}
              sx={{
                color: "text.secondary",
                mr: 2,
                "& .MuiFormControlLabel-label": {
                  fontSize: "0.75rem",
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
      <Stack direction="column">
        <Typography color="primary">
          {t("quest_edit_target.label.not_specified.note_all_target")}
        </Typography>
        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
          <SubActionButton size="small" onClick={handleSelectOdd}>
            {t("quest_edit_target.button.odd_number")}
          </SubActionButton>
          <SubActionButton size="small" onClick={handleSelectEven}>
            {t("quest_edit_target.button.even_number")}
          </SubActionButton>
          <SubActionButton
            size="small"
            onClick={handleSelectOneThird}
          >
            {t("quest_edit_target.button.one_third")}
          </SubActionButton>
          <SubActionButton
            size="small"
            onClick={handleSelectOneQuarter}
          >
            {t("quest_edit_target.button.one_quarter")}
          </SubActionButton>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default DeliveryDivisionField;
